// Updated numberToWords function for English, handling negative numbers
export const numberToWords = num => {
  if (typeof num !== 'number' || !Number.isFinite(num)) return 'Invalid number';

  const a = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const convert = n => {
    if (n === 0) return 'Zero';
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' And ' + convert(n % 100) : '');
    if (n < 1000000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' And ' + convert(n % 1000) : '');
    return 'Number too large';
  };

  if (num < 0) return `Minus ${convert(Math.abs(num))}`;
  return convert(Math.floor(num));
};

// Function to convert number to Arabic numerals, preserving negative sign
export const numberToArabicNumerals = num => {
  if (typeof num !== 'number' || !Number.isFinite(num)) return 'عدد غير صالح';
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const absNumStr = Math.abs(num).toString();
  const arabicNum = absNumStr
    .split('')
    .map(digit => arabicDigits[digit])
    .join('');
  return num < 0 ? `-${arabicNum}` : arabicNum;
};

// Updated numberToArabicWords function for Arabic, handling negative numbers
export const numberToArabicWords = num => {
  if (typeof num !== 'number' || !Number.isFinite(num)) return 'عدد غير صالح';

  const a = [
    '',
    'واحد',
    'اثنان',
    'ثلاثة',
    'أربعة',
    'خمسة',
    'ستة',
    'سبعة',
    'ثمانية',
    'تسعة',
    'عشرة',
    'أحد عشر',
    'اثنا عشر',
    'ثلاثة عشر',
    'أربعة عشر',
    'خمسة عشر',
    'ستة عشر',
    'سبعة عشر',
    'ثمانية عشر',
    'تسعة عشر',
  ];
  const b = ['', '', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
  const hundred = 'مائة';
  const thousand = 'ألف';

  const convert = n => {
    if (n === 0) return 'صفر';
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' و' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' ' + hundred + (n % 100 ? ' و' + convert(n % 100) : '');
    if (n < 1000000) return convert(Math.floor(n / 1000)) + ' ' + thousand + (n % 1000 ? ' و' + convert(n % 1000) : '');
    return 'العدد كبير جدا';
  };

  if (num < 0) return `ناقص ${convert(Math.abs(num))}`;
  return convert(Math.floor(num)); // Handle integers only
};
